import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=2ea995f6&scoped=true&"
import script from "./thumbnail.vue?vue&type=script&lang=ts&"
export * from "./thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./thumbnail.vue?vue&type=style&index=0&id=2ea995f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea995f6",
  null
  
)

export default component.exports